export var getOriginBase = function() {
    var params = new URLSearchParams(window.location.search);
    var originBaseParam = params.get('originBase');
    var origin = originBaseParam ? decodeURIComponent(originBaseParam) : localStorage.getItem('originBase');
    return origin ? new URL(origin).hostname : origin;
};
